export default __webpack_public_path__ + "static/media/info-circle-white.9121cd8f.svg";